import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingHeader = () => {
  return (
    <div className="text-center space-y-6 mb-16">
      <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
        <Icon name="Zap" size={16} />
        <span>Choose Your Plan</span>
      </div>
      
      <h1 className="text-4xl md:text-5xl font-bold text-text-primary leading-tight">
        Simple, Transparent Pricing
      </h1>
      
      <p className="text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
        Start free and scale as you grow. All plans include our core AI-powered prompt generation with different levels of customization and features.
      </p>
      
      <div className="flex items-center justify-center space-x-4 text-sm text-text-secondary">
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span>No setup fees</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span>Cancel anytime</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span>14-day free trial</span>
        </div>
      </div>
    </div>
  );
};

export default PricingHeader;